import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Box from '@material-ui/core/Box';
import DataGridPreview from '@afosto/app-components-react/DataGrid/DataGridPreview';
import LoadingWrapper from '@afosto/components-react/LoadingWrapper';
import Metadata from '@afosto/app-components-react/Metadata';
import Property from '@afosto/app-components-react/Property';
import isDefined from '@afosto/utils/isDefined';
import { getUISchema } from '../../../../components/IntegrationForm/getUISchema';
import {
  boolean as booleanFormatter,
  datetime as datetimeFormatter,
} from '@afosto/app-components-react/DataGrid/formatters';
import useConfiguration from '../../../../utils/useConfiguration';
import translations from './translations';

const IntegrationPreview = ({ app, integration, isLoading, isOpen, menu, onClose }) => {
  const intl = useIntl();

  const configurationSchema = isDefined(app?.config_schema)
    ? JSON.parse(atob(app.config_schema))
    : null;
  const configuration = useConfiguration({ app, integration });
  const uiSchemas = getUISchema(intl, app?.code, {});

  return (
    <DataGridPreview
      open={isOpen}
      onClose={onClose}
      title={intl.formatMessage(translations.title)}
      menu={menu}
    >
      <Box px={2}>
        <LoadingWrapper isLoading={isLoading}>
          <Property
            label={intl.formatMessage(translations.properties.name)}
            value={integration?.name}
          />

          <Property
            label={intl.formatMessage(translations.properties.app)}
            value={app?.name ?? integration?.app_code}
          />

          <Property
            label={intl.formatMessage(translations.properties.isInstalled)}
            value={booleanFormatter(integration?.is_installed ?? false)}
          />

          <Property
            label={intl.formatMessage(translations.properties.activeAt)}
            value={integration?.active_at && datetimeFormatter(integration?.active_at)}
          />

          <Property
            label={intl.formatMessage(translations.properties.createdAt)}
            value={integration?.created_at && datetimeFormatter(integration?.created_at)}
          />

          <Metadata
            metadata={configuration}
            schema={configurationSchema}
            uiSchema={uiSchemas?.configuration ?? {}}
          />
        </LoadingWrapper>
      </Box>
    </DataGridPreview>
  );
};

IntegrationPreview.propTypes = {
  app: PropTypes.object,
  integration: PropTypes.object,
  isLoading: PropTypes.bool,
  isOpen: PropTypes.bool,
  menu: PropTypes.array,
  onClose: PropTypes.func,
};

IntegrationPreview.defaultProps = {
  app: undefined,
  integration: undefined,
  isLoading: false,
  isOpen: false,
  menu: [],
  onClose: undefined,
};

export default IntegrationPreview;
